import React from "react";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { LabelWithToolTip } from "../../../atoms/LabelWithToolTip";

const AbaRoutingNumberForm = (props) => {
  const abaRoutingNumberField = props.register("abaRoutingNumber", { required: true });
  const correspondentAbaRoutingNumberField = props.register("correspondentAbaRoutingNumber", { required: false });
  
  const field = (label, value) => (
    <div className="vbdm__field">
      <div className="vbdm__field-label">{label}</div>
      <div className={`vbdm__field-value${!value ? ' vbdm__field-value--empty' : ''}`}>
        {value || '\u2014'}
      </div>
    </div>
  );

  return (
    <>
      {/* Currency Selection - USD only for ABA Routing Number */}
      <Row>
        <Col sm="12" md="6">
          <FormGroup>
            <LabelWithToolTip
              id="labelCurrency"
              labelText="Currency *"
              tooltipText="ABA Routing Number accounts use USD currency"
            />
            <select
              {...props.register("currencyId")}
              className="form-control"
              disabled={true}
              value={
                props.allCurrencyList?.find((c) => c.name === props.currency)?.id || ""
              }
              onChange={props.onCurrencyChanged}
            >
              <option value="">Select a currency</option>
              {(props.allCurrencyList || []).filter((c) => c.name === props.currency).map((currency) => (
                <option key={currency.id} value={currency.id}>
                  {currency.name}
                </option>
              ))}
            </select>
          </FormGroup>
        </Col>
      </Row>


      {/* Account Number */}
      <Row>
        <Col sm="12" md="12">
          <FormGroup>
            <LabelWithToolTip
              id="lblAccountNumber"
              labelText="Account Number *"
              tooltipText="Bank account number as it appears on your bank statement. Maximum 50 characters. Only alphanumeric characters allowed. Spaces and hyphens (-) are not permitted."
            />
            <input
              type="text"
              maxLength={50}
              {...props.register("bankAccountNumber")}
              className="form-control"
            />
          </FormGroup>
        </Col>
      </Row>


      {/* Beneficiary Name */}
      <Row>
        <Col sm="12" md="12">
          <FormGroup>
            <LabelWithToolTip
              id="lblBeneficiaryName"
              labelText="Beneficiary Name *"
              tooltipText="Name of the account holder as it appears on the bank account. 
              Only alphanumeric characters, spaces, parentheses, commas and periods. Ampersands (&) are not permitted."
            />
            <input
              type="text"
              {...props.register("beneficiaryBankAccountName")}
              className="form-control"
            />
          </FormGroup>
        </Col>
      </Row>

      {/* ABA Routing Number */}
      <Row>
        <Col sm="12" md="12">
          <FormGroup>
            <LabelWithToolTip
              id="lblAbaRoutingNumber"
              labelText="ABA Routing Number *"
              tooltipText="9-digit ABA Routing Number (also known as ABA RTN or Routing Transit Number) used to identify US financial institutions."
            />
            <input
              type="text"
              maxLength="9"
              {...props.register("abaRoutingNumber", { required: true })}
              className="form-control"
              onChange={props.resetMetadata}
            />
          </FormGroup>
        </Col>
      </Row>


      {/* Correspondent ABA Routing Number */}
      <Row>
        <Col sm="12" md="12">
          <FormGroup>
            <LabelWithToolTip
              id="lblCorrespondentAbaRoutingNumber"
              labelText="Correspondent Bank ABA Routing Number"
              tooltipText="9-digit ABA Routing Number of the intermediary bank if payments need to be routed through another US financial institution (optional)."
            />
            <input
              type="text"
              maxLength="9"
              {...props.register("correspondentAbaRoutingNumber")}
              className="form-control"
              onChange={props.resetMetadata}
            />
          </FormGroup>
        </Col>
      </Row>



      {/* Bank details - shown after successful ABA validation */}
      {props.isAbaRoutingNumberValidated && (
        <div className="swift-results">
          <div className="swift-results__section">
            <div className="swift-results__fields">
              <input type="hidden" {...props.register("bankName")} />
              <input type="hidden" {...props.register("bankAddress")} />
              <input type="hidden" {...props.register("bankCity")} />
              <input type="hidden" {...props.register("state")} />
              <input type="hidden" {...props.register("county")} />
              <input type="hidden" {...props.register("bankZip")} />
              <input type="hidden" {...props.register("bankCountry")} />
              <input type="hidden" {...props.register("timezone")} />
              <div className="vbdm__grid">
                {field("Beneficiary Bank ABA Routing Number", props.getValues("abaRoutingNumber"))}
                {field("Beneficiary Bank Name", props.getValues("bankName"))}
                {field("Beneficiary Bank Address", props.getValues("bankAddress"))}
                {field("Beneficiary Bank City", props.getValues("bankCity"))}
                {field("Beneficiary Bank State", props.getValues("state"))}
                {field("Beneficiary Bank County", props.getValues("county"))}
                {field("Beneficiary Bank Postal Code", props.getValues("bankZip"))}
                {field("Beneficiary Bank Country", props.getValues("bankCountry"))}
              </div>
            </div>
          </div>

          {/* Correspondent bank details - shown only when a correspondent ABA was provided and validated */}
          {props.isCorrespondentAbaValidated && props.correspondentAbaData && (
            <>
              <div className="vbdm__divider" />
              <div className="swift-results__section swift-results__section--corresponding">
                <div className="swift-results__fields">
                  <div className="vbdm__grid">
                    {field("Correspondent Bank ABA Routing Number", props.validatedCorrespondentAbaCode)}
                    {field("Correspondent Bank Name", props.correspondentAbaData.bankName)}
                    {field("Correspondent Bank Address", props.correspondentAbaData.streetAddress)}
                    {field("Correspondent Bank City", props.correspondentAbaData.city)}
                    {field("Correspondent Bank State", props.correspondentAbaData.state)}
                    {field("Correspondent Bank County", props.correspondentAbaData.county)}
                    {field("Correspondent Bank Postal Code", props.correspondentAbaData.zipCode)}
                    {field("Correspondent Bank Country", props.correspondentAbaData.country)}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};


export default AbaRoutingNumberForm;